<div class="container">
    <canvas #canvasRef class="canvas"></canvas>

    <div class="choice-selector">
        @for (choice of choices; track choice) {
            <button class="choice-button" mat-stroked-button [ngClass]="{ active: choice === selectedChoice }" (click)="selectChoice(choice)">{{ choice }}</button>
        }
    </div>
</div>
